import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import Contact from "../Contact/Contact";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
                I discovered my love for programming, and along the way, I've managed to pick up a thing or two (or maybe more, who knows? 🤷‍♂️).
              <br />
              <br />I'm well-versed in classics like
              <i>
                <b className="purple"> PHP, Javascript, and C#. </b>
              </i>
              <br />
              <br />
              My interests lie in crafting new &nbsp;
              <i>
                <b className="purple">Web Technologies and Products. </b> 
                When it comes to development, I thrive in the {" "} 
                <b className="purple">
                  backend and mobile app domains.
                </b>
              </i>
              <br />
              <br />
              As a web and app developer, I've navigated through frameworks like
               <b className="purple">{" "} Laravel, React Native, Node, CodeIgniter and .NET.</b>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/bkhan932"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/hazrat-bilal-4a2306193"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
